
import { Amplify } from 'aws-amplify';

Amplify.configure({
  API: {
    GraphQL: {
      endpoint: process.env.REACT_APP_APPSYNC_GRAPHQL_ENDPOINT || '',
      region: process.env.REACT_APP_AWS_S3_REGION || '',
      defaultAuthMode: 'apiKey',
      apiKey: process.env.REACT_APP_APPSYNC_API_KEY || '',
    }
  }
});